import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca uma requisição cujo erro HTTP é tratado LOCALMENTE pelo chamador
 * (mensagem no slot regional, fallback benigno, etc.). O error.interceptor
 * respeita a marca e NÃO dispara a mensagem global de topo — o erro continua
 * sendo propagado normalmente para o subscribe do chamador.
 *
 * Uso (no service, na criação da requisição):
 *   this.http.post(url, body, { context: contextoErroTratadoLocalmente() })
 *
 * Convenção: componentes NOVOS tratam seus erros nos slots (rtc-mensagem) e
 * marcam suas requisições; os legados continuam cobertos pelo interceptor.
 */
export const ERRO_TRATADO_LOCALMENTE = new HttpContextToken<boolean>(() => false);

export function contextoErroTratadoLocalmente(): HttpContext {
  return new HttpContext().set(ERRO_TRATADO_LOCALMENTE, true);
}
